<template>
  <div class="nb-step-svg-wrapper" :class="{ 'is-completed': completed }">
    <!-- 1. EMPRESA -->
    <svg
      v-if="step === 'guianfe_empresa'"
      class="nb-step-svg"
      viewBox="0 0 220 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="v_emp_bg" x1="110" y1="10" x2="110" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#EFF4FF" stop-opacity="0.9"/>
          <stop offset="100%" stop-color="#DBEAFE" stop-opacity="0.35"/>
        </linearGradient>
        <linearGradient id="v_emp_bldg" x1="110" y1="28" x2="110" y2="112" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFFFFF"/>
          <stop offset="100%" stop-color="#F8FAFC"/>
        </linearGradient>
        <linearGradient id="v_emp_badge" x1="128" y1="20" x2="206" y2="20" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#00376C"/>
        </linearGradient>
        <filter id="v_emp_shadow" x="124" y="16" width="88" height="52" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#004E94" flood-opacity="0.14"/>
        </filter>
        <filter id="v_emp_bldg_shadow" x="38" y="24" width="144" height="98" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="6" stdDeviation="5" flood-color="#0B1C30" flood-opacity="0.08"/>
        </filter>
      </defs>

      <rect x="15" y="10" width="190" height="110" rx="16" fill="url(#v_emp_bg)"/>
      <circle cx="175" cy="35" r="28" fill="#DBEAFE" fill-opacity="0.5"/>
      <circle cx="45" cy="85" r="22" fill="#E0F2FE" fill-opacity="0.6"/>
      <path d="M25 112H195" stroke="#CBD5E1" stroke-width="2.5" stroke-linecap="round"/>

      <g filter="url(#v_emp_bldg_shadow)">
        <rect x="46" y="60" width="40" height="52" rx="4" fill="#FFFFFF" stroke="#004E94" stroke-width="1.8"/>
        <path d="M44 60H88" stroke="#00376C" stroke-width="2.5" stroke-linecap="round"/>
        <rect x="54" y="80" width="24" height="32" rx="2" fill="#F1F5F9" stroke="#94A3B8" stroke-width="1.2"/>
        <line x1="54" y1="88" x2="78" y2="88" stroke="#CBD5E1" stroke-width="1"/>
        <line x1="54" y1="96" x2="78" y2="96" stroke="#CBD5E1" stroke-width="1"/>
        <line x1="54" y1="104" x2="78" y2="104" stroke="#CBD5E1" stroke-width="1"/>

        <!-- Main Tower -->
        <rect x="80" y="28" width="58" height="84" rx="5" fill="url(#v_emp_bldg)" stroke="#004E94" stroke-width="2"/>
        <rect x="77" y="24" width="64" height="6" rx="2.5" fill="#00376C"/>
        <line x1="109" y1="14" x2="109" y2="24" stroke="#004E94" stroke-width="2" stroke-linecap="round"/>
        <circle cx="109" cy="13" r="3" fill="#0EA5E9"/>
        <path d="M103 13C103 9.686 105.686 7 109 7C112.314 7 115 9.686 115 13" stroke="#0EA5E9" stroke-width="1.2" stroke-linecap="round" stroke-opacity="0.6"/>

        <rect x="87" y="36" width="10" height="8" rx="1.5" fill="#0EA5E9"/>
        <rect x="104" y="36" width="10" height="8" rx="1.5" fill="#38BDF8"/>
        <rect x="121" y="36" width="10" height="8" rx="1.5" fill="#0EA5E9"/>
        <rect x="87" y="50" width="10" height="8" rx="1.5" fill="#38BDF8"/>
        <rect x="104" y="50" width="10" height="8" rx="1.5" fill="#EFF4FF" stroke="#0EA5E9" stroke-width="0.8"/>
        <rect x="121" y="50" width="10" height="8" rx="1.5" fill="#38BDF8"/>
        <rect x="87" y="64" width="10" height="8" rx="1.5" fill="#0EA5E9"/>
        <rect x="104" y="64" width="10" height="8" rx="1.5" fill="#0EA5E9"/>
        <rect x="121" y="64" width="10" height="8" rx="1.5" fill="#EFF4FF" stroke="#0EA5E9" stroke-width="0.8"/>
        <rect x="87" y="78" width="10" height="8" rx="1.5" fill="#EFF4FF" stroke="#0EA5E9" stroke-width="0.8"/>
        <rect x="104" y="78" width="10" height="8" rx="1.5" fill="#38BDF8"/>
        <rect x="121" y="78" width="10" height="8" rx="1.5" fill="#0EA5E9"/>

        <!-- Door -->
        <rect x="101" y="94" width="16" height="18" rx="2" fill="#00376C"/>
        <rect x="103" y="96" width="5" height="16" rx="1" fill="#EFF4FF" fill-opacity="0.9"/>
        <rect x="110" y="96" width="5" height="16" rx="1" fill="#EFF4FF" fill-opacity="0.9"/>

        <rect x="134" y="68" width="34" height="44" rx="3" fill="#FFFFFF" stroke="#004E94" stroke-width="1.8"/>
        <path d="M132 68H170" stroke="#00376C" stroke-width="2.5" stroke-linecap="round"/>
        <rect x="140" y="76" width="8" height="7" rx="1.5" fill="#0EA5E9"/>
        <rect x="154" y="76" width="8" height="7" rx="1.5" fill="#38BDF8"/>
        <rect x="140" y="89" width="8" height="7" rx="1.5" fill="#EFF4FF" stroke="#0EA5E9" stroke-width="0.8"/>
        <rect x="154" y="89" width="8" height="7" rx="1.5" fill="#0EA5E9"/>
      </g>

      <!-- Single Clean Label Badge -->
      <g filter="url(#v_emp_shadow)">
        <rect x="128" y="20" width="78" height="38" rx="7" fill="#FFFFFF" stroke="#E2E8F0" stroke-width="1.5"/>
        <path d="M128 27C128 23.134 131.134 20 135 20H199C202.866 20 206 23.134 206 27V33H128V27Z" fill="url(#v_emp_badge)"/>
        
        <!-- SINGLE TEXT LABEL -->
        <text x="167" y="26.5" text-anchor="middle" dominant-baseline="central" fill="#FFFFFF" font-family="'Inter', sans-serif" font-size="6.5" font-weight="700" letter-spacing="0.4">DADOS DA EMPRESA</text>
        
        <rect x="135" y="38" width="34" height="3" rx="1.5" fill="#004E94"/>
        <rect x="135" y="45" width="46" height="2.5" rx="1" fill="#94A3B8"/>

        <circle cx="194" cy="42" r="6.5" fill="#10B981"/>
        <path d="M191.5 42L193.5 44L196.5 40.5" stroke="#FFFFFF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </g>

      <path d="M36 42L37.5 46L41.5 47.5L37.5 49L36 53L34.5 49L30.5 47.5L34.5 46L36 42Z" fill="#F59E0B"/>
    </svg>

    <!-- 2. CERTIFICADO DIGITAL -->
    <svg
      v-else-if="step === 'guianfe_certificado'"
      class="nb-step-svg"
      viewBox="0 0 220 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="v_cert_bg" x1="110" y1="10" x2="110" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#EFF4FF" stop-opacity="0.9"/>
          <stop offset="100%" stop-color="#DBEAFE" stop-opacity="0.35"/>
        </linearGradient>
        <linearGradient id="v_cert_card" x1="38" y1="28" x2="148" y2="102" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFFFFF"/>
          <stop offset="100%" stop-color="#F8FAFC"/>
        </linearGradient>
        <linearGradient id="v_cert_hdr" x1="36" y1="28" x2="148" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#00376C"/>
        </linearGradient>
        <linearGradient id="v_cert_chip" x1="50" y1="50" x2="70" y2="68" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FBBF24"/>
          <stop offset="100%" stop-color="#D97706"/>
        </linearGradient>
        <linearGradient id="v_cert_lock" x1="140" y1="52" x2="182" y2="94" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#002D57"/>
        </linearGradient>
        <filter id="v_cert_card_shadow" x="30" y="24" width="128" height="88" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="5" stdDeviation="5" flood-color="#0B1C30" flood-opacity="0.09"/>
        </filter>
        <filter id="v_cert_lock_shadow" x="126" y="26" width="68" height="84" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="6" stdDeviation="6" flood-color="#004E94" flood-opacity="0.25"/>
        </filter>
      </defs>

      <rect x="15" y="10" width="190" height="110" rx="16" fill="url(#v_cert_bg)"/>
      <circle cx="160" cy="65" r="38" fill="#DBEAFE" fill-opacity="0.4"/>
      <circle cx="160" cy="65" r="48" stroke="#BFDBFE" stroke-width="1" stroke-dasharray="3 3"/>

      <!-- Certificate Card (Width 112) -->
      <g filter="url(#v_cert_card_shadow)">
        <rect x="36" y="28" width="112" height="74" rx="8" fill="url(#v_cert_card)" stroke="#004E94" stroke-width="1.8"/>
        <path d="M36 36C36 31.582 39.582 28 44 28H140C144.418 28 148 31.582 148 36V44H36V36Z" fill="url(#v_cert_hdr)"/>
        
        <!-- SINGLE TEXT LABEL -->
        <text x="92" y="36" text-anchor="middle" dominant-baseline="central" fill="#FFFFFF" font-family="'Inter', sans-serif" font-size="7.5" font-weight="700" letter-spacing="0.5">{{ label || 'CERTIFICADO A1 / A3' }}</text>

        <!-- Gold EMV Chip -->
        <rect x="48" y="52" width="22" height="18" rx="3.5" fill="url(#v_cert_chip)" stroke="#B45309" stroke-width="1"/>
        <line x1="48" y1="61" x2="70" y2="61" stroke="#B45309" stroke-width="0.8"/>
        <line x1="59" y1="52" x2="59" y2="70" stroke="#B45309" stroke-width="0.8"/>
        <rect x="54" y="56" width="10" height="10" rx="1" fill="#FEF3C7" stroke="#B45309" stroke-width="0.7"/>

        <!-- Metadata Skeleton -->
        <rect x="76" y="53" width="46" height="3" rx="1.5" fill="#004E94"/>
        <rect x="76" y="60" width="56" height="2.5" rx="1" fill="#64748B"/>
        <rect x="76" y="66" width="38" height="2.5" rx="1" fill="#94A3B8"/>

        <!-- Graphic status pill (no cramped text) -->
        <rect x="48" y="78" width="36" height="12" rx="4" fill="#ECFDF5" stroke="#A7F3D0" stroke-width="1"/>
        <circle cx="55" cy="84" r="2.5" fill="#10B981"/>
        <rect x="61" y="82.5" width="18" height="3" rx="1.5" fill="#059669"/>
      </g>

      <!-- Padlock -->
      <g filter="url(#v_cert_lock_shadow)">
        <path d="M148 52V42C148 35.373 153.373 30 160 30C166.627 30 172 35.373 172 42V52" stroke="#F59E0B" stroke-width="4.5" stroke-linecap="round"/>
        <rect x="138" y="50" width="44" height="42" rx="9" fill="url(#v_cert_lock)" stroke="#00376C" stroke-width="1.5"/>
        <circle cx="160" cy="68" r="4.5" fill="#FFFFFF"/>
        <path d="M158.5 70L157.5 77H162.5L161.5 70H158.5Z" fill="#FFFFFF"/>
        <circle cx="178" cy="86" r="9" fill="#10B981" stroke="#FFFFFF" stroke-width="2"/>
        <path d="M174.5 86L177 88.5L181.5 83.5" stroke="#FFFFFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </g>

      <path d="M192 48L193.5 52L197.5 53.5L193.5 55L192 59L190.5 55L186.5 53.5L190.5 52L192 48Z" fill="#F59E0B"/>
    </svg>

    <!-- 3. PRODUTOS E SERVIÇOS -->
    <svg
      v-else-if="step === 'guianfe_item'"
      class="nb-step-svg"
      viewBox="0 0 220 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="v_item_bg" x1="110" y1="10" x2="110" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#EFF4FF" stop-opacity="0.9"/>
          <stop offset="100%" stop-color="#DBEAFE" stop-opacity="0.35"/>
        </linearGradient>
        <linearGradient id="v_item_top" x1="60" y1="36" x2="135" y2="60" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#DBEAFE"/>
          <stop offset="100%" stop-color="#BFDBFE"/>
        </linearGradient>
        <linearGradient id="v_item_left" x1="60" y1="58" x2="105" y2="105" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#00376C"/>
        </linearGradient>
        <linearGradient id="v_item_right" x1="105" y1="58" x2="150" y2="105" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#0EA5E9"/>
          <stop offset="100%" stop-color="#0284C7"/>
        </linearGradient>
        <linearGradient id="v_item_tag" x1="136" y1="22" x2="204" y2="62" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFFFFF"/>
          <stop offset="100%" stop-color="#F8FAFC"/>
        </linearGradient>
        <linearGradient id="v_item_plus" x1="32" y1="32" x2="60" y2="60" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#0EA5E9"/>
        </linearGradient>
        <filter id="v_item_box_shadow" x="50" y="32" width="112" height="84" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="8" stdDeviation="6" flood-color="#004E94" flood-opacity="0.22"/>
        </filter>
        <filter id="v_item_tag_shadow" x="128" y="16" width="82" height="56" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#0B1C30" flood-opacity="0.12"/>
        </filter>
        <filter id="v_item_plus_shadow" x="28" y="28" width="38" height="38" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#004E94" flood-opacity="0.25"/>
        </filter>
      </defs>

      <rect x="15" y="10" width="190" height="110" rx="16" fill="url(#v_item_bg)"/>
      <circle cx="105" cy="72" r="42" fill="#DBEAFE" fill-opacity="0.5"/>
      <ellipse cx="106" cy="110" rx="48" ry="7" fill="#CBD5E1" fill-opacity="0.7"/>

      <!-- 3D Box -->
      <g filter="url(#v_item_box_shadow)">
        <path d="M106 38L148 54L106 70L64 54L106 38Z" fill="url(#v_item_top)" stroke="#00376C" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M96 42L116 49.5L116 66L96 58.5L96 42Z" fill="#93C5FD" fill-opacity="0.8"/>
        
        <path d="M64 54L106 70V105L64 89V54Z" fill="url(#v_item_left)" stroke="#00376C" stroke-width="1.5" stroke-linejoin="round"/>
        <g transform="matrix(1 0.38 0 0.92 72 63)">
          <rect x="0" y="0" width="24" height="16" rx="2" fill="#FFFFFF" fill-opacity="0.95"/>
          <rect x="3" y="3" width="1.5" height="10" fill="#0B1C30"/>
          <rect x="6" y="3" width="2.5" height="10" fill="#0B1C30"/>
          <rect x="9.5" y="3" width="1" height="10" fill="#0B1C30"/>
          <rect x="12" y="3" width="3" height="10" fill="#0B1C30"/>
          <rect x="16" y="3" width="1.2" height="10" fill="#0B1C30"/>
          <rect x="18.5" y="3" width="2" height="10" fill="#0B1C30"/>
        </g>

        <path d="M106 70L148 54V89L106 105V70Z" fill="url(#v_item_right)" stroke="#00376C" stroke-width="1.5" stroke-linejoin="round"/>
        <g transform="matrix(1 -0.38 0 0.92 118 84)">
          <path d="M5 12V4M5 4L2 7M5 4L8 7" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 12V4M14 4L11 7M14 4L17 7" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </g>

      <!-- Single Clean Label Tag: PRODUTOS -->
      <g filter="url(#v_item_tag_shadow)">
        <!-- Tag String -->
        <path d="M150 22C144 16 136 18 130 24" stroke="#004E94" stroke-width="1.5" stroke-linecap="round" fill="none"/>
        
        <!-- Tag Body (Width 70, ample space for 8-char label) -->
        <rect x="134" y="22" width="70" height="38" rx="7" fill="url(#v_item_tag)" stroke="#0EA5E9" stroke-width="1.8"/>
        
        <!-- Top accent pill -->
        <path d="M134 29C134 25.134 137.134 22 141 22H197C200.866 22 204 25.134 204 29V34H134V29Z" fill="#EFF4FF"/>

        <!-- SINGLE TEXT LABEL -->
        <text x="169" y="28" text-anchor="middle" dominant-baseline="central" fill="#004E94" font-family="'Inter', sans-serif" font-size="7.5" font-weight="800" letter-spacing="0.5">PRODUTOS</text>

        <!-- Visual Skeleton / Fiscal Indicators (no overflowing text) -->
        <rect x="142" y="42" width="22" height="6" rx="2" fill="#ECFDF5" stroke="#A7F3D0" stroke-width="0.8"/>
        <rect x="145" y="44" width="16" height="2" rx="1" fill="#059669"/>
        <rect x="168" y="43.5" width="28" height="3" rx="1.5" fill="#004E94"/>
      </g>

      <!-- Plus Badge -->
      <g filter="url(#v_item_plus_shadow)">
        <circle cx="47" cy="47" r="14" fill="url(#v_item_plus_grad)"/>
        <path d="M47 41V53M41 47H53" stroke="#FFFFFF" stroke-width="2.5" stroke-linecap="round"/>
      </g>
      <path d="M34 85L35.5 88.5L39 90L35.5 91.5L34 95L32.5 91.5L29 90L32.5 88.5L34 85Z" fill="#F59E0B"/>
    </svg>

    <!-- 4. CLIENTES E FORNECEDORES -->
    <svg
      v-else-if="step === 'guianfe_part'"
      class="nb-step-svg"
      viewBox="0 0 220 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="v_part_bg" x1="110" y1="10" x2="110" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#EFF4FF" stop-opacity="0.9"/>
          <stop offset="100%" stop-color="#DBEAFE" stop-opacity="0.35"/>
        </linearGradient>
        <linearGradient id="v_part_card" x1="42" y1="24" x2="152" y2="104" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFFFFF"/>
          <stop offset="100%" stop-color="#F8FAFC"/>
        </linearGradient>
        <linearGradient id="v_part_hdr" x1="42" y1="24" x2="152" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#00376C"/>
        </linearGradient>
        <linearGradient id="v_part_sup" x1="140" y1="42" x2="186" y2="88" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#0EA5E9"/>
          <stop offset="100%" stop-color="#0284C7"/>
        </linearGradient>
        <filter id="v_part_card_shadow" x="34" y="20" width="128" height="92" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="5" stdDeviation="5" flood-color="#0B1C30" flood-opacity="0.09"/>
        </filter>
        <filter id="v_part_sup_shadow" x="134" y="38" width="58" height="58" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#0EA5E9" flood-opacity="0.25"/>
        </filter>
      </defs>

      <rect x="15" y="10" width="190" height="110" rx="16" fill="url(#v_part_bg)"/>
      <circle cx="95" cy="65" r="42" fill="#DBEAFE" fill-opacity="0.4"/>
      <circle cx="165" cy="65" r="32" fill="#E0F2FE" fill-opacity="0.5"/>
      <path d="M120 62C130 62 135 62 145 62" stroke="#38BDF8" stroke-width="2.5" stroke-dasharray="3 3"/>

      <!-- Profile Card (Width 110) -->
      <g filter="url(#v_part_card_shadow)">
        <rect x="42" y="24" width="110" height="78" rx="8" fill="url(#v_part_card)" stroke="#004E94" stroke-width="1.8"/>
        <path d="M42 32C42 27.582 45.582 24 50 24H144C148.418 24 152 27.582 152 32V40H42V32Z" fill="url(#v_part_hdr)"/>
        
        <!-- SINGLE TEXT LABEL -->
        <text x="97" y="32" text-anchor="middle" dominant-baseline="central" fill="#FFFFFF" font-family="'Inter', sans-serif" font-size="7" font-weight="700" letter-spacing="0.5">CLIENTES E PARCEIROS</text>
        
        <circle cx="64" cy="58" r="13" fill="#EFF4FF" stroke="#004E94" stroke-width="1.5"/>
        <circle cx="64" cy="54" r="4.5" fill="#004E94"/>
        <path d="M55 68C55 63 59 62.5 64 62.5C69 62.5 73 63 73 68" fill="#004E94"/>

        <rect x="85" y="49" width="56" height="4" rx="2" fill="#0B1C30"/>
        <rect x="85" y="57" width="42" height="3" rx="1.5" fill="#64748B"/>
        <rect x="85" y="63" width="34" height="2.5" rx="1" fill="#94A3B8"/>

        <!-- Graphic status indicators (no text) -->
        <rect x="52" y="78" width="40" height="14" rx="4" fill="#EFF4FF" stroke="#BFDBFE" stroke-width="1"/>
        <circle cx="60" cy="85" r="3.5" fill="#10B981"/>
        <path d="M58.5 85L59.5 86L61.5 84" stroke="#FFFFFF" stroke-width="1" stroke-linecap="round"/>
        <rect x="67" y="83.5" width="18" height="3" rx="1.5" fill="#004E94"/>

        <g transform="translate(104, 76)">
          <circle cx="7" cy="7" r="7" fill="#FEF2F2" stroke="#FECACA" stroke-width="1"/>
          <path d="M7 4C5.343 4 4 5.343 4 7C4 9.25 7 12 7 12C7 12 10 9.25 10 7C10 5.343 8.657 4 7 4Z" fill="#EF4444"/>
          <circle cx="7" cy="7" r="1.2" fill="#FFFFFF"/>
        </g>
        <rect x="122" y="82" width="22" height="3" rx="1.5" fill="#CBD5E1"/>
      </g>

      <!-- Partner Badge -->
      <g filter="url(#v_part_sup_shadow)">
        <circle cx="163" cy="62" r="22" fill="url(#v_part_sup)" stroke="#FFFFFF" stroke-width="2"/>
        <circle cx="163" cy="56" r="6" fill="#FFFFFF"/>
        <path d="M151 74C151 67.5 156.5 67 163 67C169.5 67 175 67.5 175 74" fill="#FFFFFF"/>
        <path d="M161.5 67L163 71L164.5 67H161.5Z" fill="#004E94"/>
      </g>
      <circle cx="178" cy="77" r="8.5" fill="#10B981" stroke="#FFFFFF" stroke-width="1.8"/>
      <path d="M174.5 77L177 79.5L181.5 74.5" stroke="#FFFFFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M36 82L37.5 85.5L41 87L37.5 88.5L36 92L34.5 88.5L31 87L34.5 85.5L36 82Z" fill="#F59E0B"/>
    </svg>

    <!-- 5. PEDIDO DE VENDA -->
    <svg
      v-else-if="step === 'guianfe_venda'"
      class="nb-step-svg"
      viewBox="0 0 220 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="v_venda_bg" x1="110" y1="10" x2="110" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#EFF4FF" stop-opacity="0.9"/>
          <stop offset="100%" stop-color="#DBEAFE" stop-opacity="0.35"/>
        </linearGradient>
        <linearGradient id="v_venda_clip" x1="40" y1="20" x2="135" y2="108" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFFFFF"/>
          <stop offset="100%" stop-color="#F8FAFC"/>
        </linearGradient>
        <linearGradient id="v_venda_cart" x1="120" y1="52" x2="175" y2="100" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#00376C"/>
        </linearGradient>
        <linearGradient id="v_venda_coin" x1="165" y1="22" x2="195" y2="52" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FBBF24"/>
          <stop offset="100%" stop-color="#D97706"/>
        </linearGradient>
        <filter id="v_venda_clip_shadow" x="32" y="16" width="112" height="98" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="5" stdDeviation="5" flood-color="#0B1C30" flood-opacity="0.09"/>
        </filter>
        <filter id="v_venda_cart_shadow" x="110" y="44" width="76" height="66" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="6" stdDeviation="5" flood-color="#004E94" flood-opacity="0.25"/>
        </filter>
        <filter id="v_venda_coin_shadow" x="160" y="18" width="40" height="40" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#D97706" flood-opacity="0.3"/>
        </filter>
      </defs>

      <rect x="15" y="10" width="190" height="110" rx="16" fill="url(#v_venda_bg)"/>
      <circle cx="85" cy="65" r="42" fill="#DBEAFE" fill-opacity="0.4"/>

      <!-- Clipboard (Width 94) -->
      <g filter="url(#v_venda_clip_shadow)">
        <rect x="40" y="22" width="94" height="84" rx="7" fill="url(#v_venda_clip)" stroke="#004E94" stroke-width="1.8"/>
        <rect x="70" y="18" width="34" height="8" rx="2.5" fill="#00376C"/>
        <rect x="78" y="15" width="18" height="5" rx="1.5" fill="#94A3B8"/>
        <circle cx="87" cy="22" r="2" fill="#FFFFFF"/>

        <!-- SINGLE TEXT LABEL -->
        <text x="87" y="36" text-anchor="middle" dominant-baseline="central" fill="#004E94" font-family="'Inter', sans-serif" font-size="7.5" font-weight="800" letter-spacing="0.4">PEDIDO DE VENDA</text>
        <line x1="50" y1="43" x2="124" y2="43" stroke="#E2E8F0" stroke-width="1"/>

        <!-- Items with checks -->
        <circle cx="54" cy="51" r="3.5" fill="#ECFDF5" stroke="#10B981" stroke-width="1"/>
        <path d="M52.5 51L53.5 52L55.5 50" stroke="#10B981" stroke-width="1" stroke-linecap="round"/>
        <rect x="62" y="49.5" width="40" height="3" rx="1.5" fill="#334155"/>
        <rect x="108" y="49.5" width="14" height="3" rx="1.5" fill="#0EA5E9"/>

        <circle cx="54" cy="61" r="3.5" fill="#ECFDF5" stroke="#10B981" stroke-width="1"/>
        <path d="M52.5 61L53.5 62L55.5 60" stroke="#10B981" stroke-width="1" stroke-linecap="round"/>
        <rect x="62" y="59.5" width="34" height="3" rx="1.5" fill="#334155"/>
        <rect x="108" y="59.5" width="14" height="3" rx="1.5" fill="#0EA5E9"/>

        <circle cx="54" cy="71" r="3.5" fill="#EFF4FF" stroke="#004E94" stroke-width="1"/>
        <rect x="62" y="69.5" width="38" height="3" rx="1.5" fill="#94A3B8"/>
        <rect x="108" y="69.5" width="14" height="3" rx="1.5" fill="#0EA5E9"/>

        <!-- Graphic Total Bar -->
        <rect x="48" y="80" width="78" height="18" rx="4" fill="#EFF4FF" stroke="#BFDBFE" stroke-width="1"/>
        <rect x="54" y="87" width="22" height="4" rx="2" fill="#004E94"/>
        <rect x="84" y="86" width="36" height="6" rx="2" fill="#ECFDF5" stroke="#A7F3D0" stroke-width="0.8"/>
        <rect x="88" y="88" width="28" height="2" rx="1" fill="#059669"/>
      </g>

      <!-- Cart -->
      <g filter="url(#v_venda_cart_shadow)">
        <path d="M120 54H127L133 80H166L172 58H130" stroke="#0EA5E9" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M128 58H170L165 79H133L128 58Z" fill="url(#v_venda_cart)" fill-opacity="0.9" stroke="#004E94" stroke-width="1.5"/>
        
        <line x1="137" y1="58" x2="139" y2="79" stroke="#38BDF8" stroke-width="1" stroke-opacity="0.6"/>
        <line x1="147" y1="58" x2="147" y2="79" stroke="#38BDF8" stroke-width="1" stroke-opacity="0.6"/>
        <line x1="157" y1="58" x2="155" y2="79" stroke="#38BDF8" stroke-width="1" stroke-opacity="0.6"/>
        <line x1="130" y1="68" x2="168" y2="68" stroke="#38BDF8" stroke-width="1" stroke-opacity="0.6"/>

        <rect x="136" y="48" width="12" height="12" rx="2" fill="#FEF3C7" stroke="#F59E0B" stroke-width="1"/>
        <rect x="148" y="44" width="14" height="14" rx="2" fill="#ECFDF5" stroke="#10B981" stroke-width="1"/>

        <circle cx="137" cy="88" r="4.5" fill="#00376C" stroke="#FFFFFF" stroke-width="1.2"/>
        <circle cx="137" cy="88" r="1.5" fill="#FFFFFF"/>
        <circle cx="162" cy="88" r="4.5" fill="#00376C" stroke="#FFFFFF" stroke-width="1.2"/>
        <circle cx="162" cy="88" r="1.5" fill="#FFFFFF"/>
      </g>

      <!-- Currency Badge (Graphic vector symbol) -->
      <g filter="url(#v_venda_coin_shadow)">
        <circle cx="178" cy="36" r="14" fill="url(#v_venda_coin_grad)" stroke="#B45309" stroke-width="1.5"/>
        <circle cx="178" cy="36" r="11" stroke="#FEF3C7" stroke-width="1" stroke-dasharray="2 2"/>
        <path d="M178 28V44M174 32C174 30.5 175.5 29.5 178 29.5C180.5 29.5 182 30.8 182 32.5C182 34.5 180 35.2 178 35.8C175.8 36.4 174 37.2 174 39.5C174 41.2 175.5 42.5 178 42.5C180.5 42.5 182 41.5 182 40" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>
      </g>

      <circle cx="188" cy="72" r="8" fill="#10B981" stroke="#FFFFFF" stroke-width="1.8"/>
      <path d="M185 75L188 70L191 75M188 70V76" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <!-- 6. NOTA FISCAL -->
    <svg
      v-else-if="step === 'guianfe_nf'"
      class="nb-step-svg"
      viewBox="0 0 220 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="v_nf_bg" x1="110" y1="10" x2="110" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#EFF4FF" stop-opacity="0.9"/>
          <stop offset="100%" stop-color="#DBEAFE" stop-opacity="0.35"/>
        </linearGradient>
        <linearGradient id="v_nf_doc" x1="50" y1="16" x2="145" y2="114" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#FFFFFF"/>
          <stop offset="100%" stop-color="#F8FAFC"/>
        </linearGradient>
        <linearGradient id="v_nf_hdr" x1="50" y1="18" x2="144" y2="18" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#004E94"/>
          <stop offset="100%" stop-color="#00376C"/>
        </linearGradient>
        <linearGradient id="v_nf_stamp" x1="130" y1="58" x2="182" y2="106" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#ECFDF5"/>
          <stop offset="100%" stop-color="#D1FAE5"/>
        </linearGradient>
        <linearGradient id="v_nf_rocket" x1="155" y1="20" x2="185" y2="50" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#0EA5E9"/>
          <stop offset="100%" stop-color="#004E94"/>
        </linearGradient>
        <filter id="v_nf_doc_shadow" x="42" y="12" width="112" height="106" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="6" stdDeviation="6" flood-color="#004E94" flood-opacity="0.16"/>
        </filter>
        <filter id="v_nf_stamp_shadow" x="124" y="52" width="66" height="66" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="4" stdDeviation="4" flood-color="#10B981" flood-opacity="0.25"/>
        </filter>
      </defs>

      <rect x="15" y="10" width="190" height="110" rx="16" fill="url(#v_nf_bg)"/>
      <circle cx="100" cy="65" r="44" fill="#DBEAFE" fill-opacity="0.4"/>
      <path d="M152 24C162 20 174 21 184 26" stroke="#38BDF8" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 3"/>
      <path d="M158 18C172 14 186 16 198 22" stroke="#0EA5E9" stroke-width="2" stroke-linecap="round"/>

      <!-- NF-e DANFE Document (Width 94) -->
      <g filter="url(#v_nf_doc_shadow)">
        <rect x="50" y="18" width="94" height="92" rx="7" fill="url(#v_nf_doc)" stroke="#004E94" stroke-width="1.8"/>
        <path d="M50 25C50 21.134 53.134 18 57 18H137C140.866 18 144 21.134 144 25V36H50V25Z" fill="url(#v_nf_hdr)"/>
        
        <!-- SINGLE TEXT LABEL -->
        <text x="97" y="27" text-anchor="middle" dominant-baseline="central" fill="#FFFFFF" font-family="'Inter', sans-serif" font-size="7" font-weight="800" letter-spacing="0.5">NOTA FISCAL (NF-e)</text>

        <!-- Barcode -->
        <g transform="translate(58, 41)">
          <rect x="0" y="0" width="78" height="11" rx="2" fill="#FFFFFF" stroke="#E2E8F0" stroke-width="0.8"/>
          <rect x="4" y="2" width="1.5" height="7" fill="#0B1C30"/>
          <rect x="7" y="2" width="2.5" height="7" fill="#0B1C30"/>
          <rect x="11" y="2" width="1" height="7" fill="#0B1C30"/>
          <rect x="13.5" y="2" width="3" height="7" fill="#0B1C30"/>
          <rect x="18" y="2" width="1.5" height="7" fill="#0B1C30"/>
          <rect x="21" y="2" width="2" height="7" fill="#0B1C30"/>
          <rect x="25" y="2" width="1" height="7" fill="#0B1C30"/>
          <rect x="28" y="2" width="2.5" height="7" fill="#0B1C30"/>
          <rect x="32" y="2" width="1.5" height="7" fill="#0B1C30"/>
          <rect x="35" y="2" width="3" height="7" fill="#0B1C30"/>
          <rect x="40" y="2" width="1" height="7" fill="#0B1C30"/>
          <rect x="43" y="2" width="2" height="7" fill="#0B1C30"/>
          <rect x="47" y="2" width="3" height="7" fill="#0B1C30"/>
          <rect x="52" y="2" width="1.5" height="7" fill="#0B1C30"/>
          <rect x="55" y="2" width="2" height="7" fill="#0B1C30"/>
          <rect x="59" y="2" width="1" height="7" fill="#0B1C30"/>
          <rect x="62" y="2" width="3" height="7" fill="#0B1C30"/>
          <rect x="67" y="2" width="2" height="7" fill="#0B1C30"/>
          <rect x="71" y="2" width="1.5" height="7" fill="#0B1C30"/>
        </g>

        <rect x="58" y="56" width="34" height="2.5" rx="1.2" fill="#004E94"/>
        <rect x="58" y="61" width="46" height="2" rx="1" fill="#94A3B8"/>
        <rect x="58" y="65" width="38" height="2" rx="1" fill="#CBD5E1"/>

        <!-- QR Code -->
        <g transform="translate(58, 73)">
          <rect x="0" y="0" width="26" height="26" rx="3" fill="#FFFFFF" stroke="#004E94" stroke-width="1.2"/>
          <rect x="2" y="2" width="7" height="7" fill="#004E94"/>
          <rect x="3.5" y="3.5" width="4" height="4" fill="#FFFFFF"/>
          <rect x="4.5" y="4.5" width="2" height="2" fill="#004E94"/>
          
          <rect x="17" y="2" width="7" height="7" fill="#004E94"/>
          <rect x="18.5" y="3.5" width="4" height="4" fill="#FFFFFF"/>
          <rect x="19.5" y="4.5" width="2" height="2" fill="#004E94"/>
          
          <rect x="2" y="17" width="7" height="7" fill="#004E94"/>
          <rect x="3.5" y="18.5" width="4" height="4" fill="#FFFFFF"/>
          <rect x="4.5" y="19.5" width="2" height="2" fill="#004E94"/>
          
          <rect x="11" y="3" width="2" height="2" fill="#004E94"/>
          <rect x="14" y="5" width="2" height="2" fill="#004E94"/>
          <rect x="11" y="11" width="4" height="4" fill="#004E94"/>
          <rect x="18" y="11" width="2" height="3" fill="#004E94"/>
          <rect x="11" y="17" width="3" height="2" fill="#004E94"/>
          <rect x="17" y="17" width="2" height="4" fill="#004E94"/>
          <rect x="21" y="21" width="3" height="3" fill="#004E94"/>
        </g>

        <!-- Skeleton fiscal lines -->
        <rect x="90" y="76" width="32" height="2.5" rx="1.2" fill="#64748B"/>
        <rect x="90" y="81" width="26" height="2.5" rx="1.2" fill="#94A3B8"/>
        <rect x="90" y="89" width="36" height="6" rx="2" fill="#ECFDF5" stroke="#A7F3D0" stroke-width="0.8"/>
        <rect x="94" y="91" width="24" height="2" rx="1" fill="#059669"/>
      </g>

      <!-- SEFAZ Certification Seal (Graphic only, no cramped text) -->
      <g filter="url(#v_nf_stamp_shadow)" transform="rotate(-6 156 80)">
        <circle cx="156" cy="80" r="22" fill="url(#v_nf_stamp_grad)" stroke="#10B981" stroke-width="2.5"/>
        <circle cx="156" cy="80" r="18" stroke="#34D399" stroke-width="1" stroke-dasharray="3 2"/>
        
        <circle cx="156" cy="77" r="9" fill="#10B981"/>
        <path d="M152 77L155 80L160.5 74.5" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        
        <circle cx="149" cy="91" r="1.5" fill="#059669"/>
        <circle cx="156" cy="92" r="2" fill="#059669"/>
        <circle cx="163" cy="91" r="1.5" fill="#059669"/>
      </g>

      <!-- Cloud Rocket -->
      <path d="M185 35L178 37L176 44L173 41L174 38L171 37L178 30L185 35Z" fill="url(#v_nf_rocket_grad)"/>
      <circle cx="180" cy="34" r="1.2" fill="#FFFFFF"/>
      <path d="M174 41L169 44L171 40L174 41Z" fill="#F59E0B"/>
      <path d="M34 82L35.5 85.5L39 87L35.5 88.5L34 92L32.5 88.5L29 87L32.5 85.5L34 82Z" fill="#F59E0B"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: "guia-step-svg",
  props: {
    step: {
      type: String,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.nb-step-svg-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.25s ease, filter 0.25s ease;
}

.nb-step-svg {
  width: 100%;
  max-width: 260px;
  height: auto;
  aspect-ratio: 220 / 130;
  display: block;
}

.nb-step-svg-wrapper:hover .nb-step-svg {
  transform: scale(1.02);
  transition: transform 0.25s ease;
}

.nb-step-svg-wrapper.is-completed {
  filter: saturate(1.05);
}
</style>



// WEBPACK FOOTER //
// src/dashboards/guia-step-svg.vue